export default {
    data() {
        return {};
    },
    methods: {
        changePage(page) {
            let url = new URL('', this.tableUrl);
            const newUrl = url.origin + url.pathname + '?page=' + page;
            console.log(newUrl);
            this.tableUrl = newUrl;
        }
    },
};
